import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import FiscContratosService from '../../../services/fiscContratos'
import Fiscal from './fiscal';

const ListarFiscais = () => {

    const [fiscais, setFiscais] = useState([]);
    const [secs, setSecs] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchFiscais() {
        await montaSelectLocais();
        const response = await FiscContratosService.listar();
        if (response.data.length >= 1) {
            setFiscais(response.data)
            setVazio(false)
        } else {
            setFiscais([])
            setVazio(true)
        }
    }

    const montaSelectLocais = async () => {
        let prod = await FiscContratosService.listar();
        const uniqueSecs = [...new Map(prod.data.map(item => [item['secretaria'], item])).values()];
        setSecs(uniqueSecs)
    }

    useEffect(() => {
        fetchFiscais();
    }, []);

    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setFiscais={setFiscais}
                    setVazio={setVazio}
                    secs={secs}
                    fetchFiscais={fetchFiscais}
                    fiscais={fiscais}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <br/>
                    <h5>Fiscais de Contratos firmados pela Prefeitura</h5>
                    <h6>Na Prefeitura Municipal de Macuco, fiscais de contratos são responsáveis por fiscalizar diversos contratos firmados por determinados setores, departamentos, tipo de compra ou secretarias. No campo "objeto", é descrito por qual setor o fiscal é responsável por fiscalizar TODOS contratos.</h6>
                    <Row xs={1} lg={3}>
                        {fiscais.map((fiscal, index) =>
                            <Fiscal
                                fiscal={fiscal}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarFiscais;